import React from 'react'
import PropTypes from 'prop-types'

function StepCopy({ children }) {
  return (
    <div className="mx-auto my-12 text-left md:my-16 md:text-center">
      {children}
    </div>
  )
}

StepCopy.propTypes = {
  children: PropTypes.any.isRequired,
}

export default StepCopy
